var BottomSheetDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/use-app-1638775723.png',
  heading: 'Want an extra 20% off?',
  description: 'Download the Goibibo app and use code ONAPP to get an extra 20% off on this booking.',
  ctaText: 'DOWNLOAD AND SAVE MORE',
  continueText: 'Continue on mobile site'
};
var TopBannerDefaultText = {
  heading: 'Save more on APP!!',
  subHeading: 'Get INR 1700 DISCOUNT* only on our APP. Use Code: GOAPP',
  logoUrl: 'https://gos3.ibcdn.com/top-bar-mweb2app-1659001525.gif',
  ctaTextInstall: 'OPEN',
  ctaTextOpen: 'OPEN',
  bgColor: '#FFC24A',
  ctaBgColor: '#ffffff',
  ctaTextColor: '#F16736',
  ctaBorderColor: 'transparent',
  headingTextColor: '#46484d',
  fallbackHeading: 'Save more on APP!!',
  fallbackSubHeading: 'Get INR 1700 DISCOUNT* only on our APP. Use Code: GOAPP',
  src: '',
  dest: '',
  fullWidthCtaBtnText: 'Get App',
  showFullBtnInTopNav: false,
  fullBtnCtaTextOpen: 'Open App Now',
  fullBtnCtaTextInstall: 'Get App Now',
  fullBtnCtaTextColor: '#3393FE',
  fullBtnCtaBgColor: '#ffffff',
  subHeadingWithTimer: 'Get INR 100 worth goCash by logging in App.'
};
var DesktopDrawerDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/use-app-1638775723.png',
  heading: 'Download App',
  description: 'Download app to get exclusive offers',
  ctaText: 'Download App',
  bgColor: '#fff',
  ctaTextColor: '#000'
};
var InlineCardBannerDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/offers-1646300530.png',
  heading: 'Save up to Rs.450 extra in app',
  codeLabel: '',
  code: '',
  codeColor: '',
  cardHeight: ''
};
var InlineCardBannerDesktopDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/gi-app-1660799492.png',
  heading: 'Exclusive offers on the app!',
  description: 'Download the Goibibo app and save more'
};
var FullPageDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/offers-1647417147.png',
  heading: 'Want an extra 20% off?',
  description: 'Download the Goibibo app and get an extra 20% off on this booking.',
  ctaText: 'DOWNLOAD AND SAVE MORE',
  continueText: 'Continue to mobile site'
};
var MwebRecentSearchCardText = {
  ctaText: 'Download the App now',
  ctaTextColor: '#2276e3',
  logoUrl: 'https://gos3.ibcdn.com/recentSearchAppBanner-1649056608.svg'
};
var DwebRecentSearchCardText = {
  heading: 'Upto ₹1700&#42; Off',
  description: 'Valid only on app',
  qrLabel: 'Scan to download'
};
var BottomBarDefaultText = {
  ctaText: 'Manage Booking via App',
  ctaTextColor: '#fff',
  backgroundColor: '#FF6D38'
};
var DesktopSidePopupDefaultText = {
  qrheading: 'Scan to download App',
  qrheadingtextcolor: '#000000',
  heading: 'Save upto ₹1700* on APP. Use code: GOAPP',
  headingtextcolor: '#FFFFFF',
  headingbgcolor: '#141823',
  qrLogoUrl: 'https://gos3.ibcdn.com/dweb2app-qr-logo-1664447597.png',
  qrImageUrl: '',
  fullCoverImage: '',
  fullCoverURL: '',
  removeHeading: false
};
var FloatingBarDefaultText = {
  ctaBgColor: 'rgb(255, 109, 56)',
  ctaTextColor: '#FFFFFF',
  ctaBorderColor: 'rgb(255, 109, 56)',
  ctaText: 'Open In App'
};

var HOC_API_RESPONSE = 'growth_non_int_HOC_API_RESPONSE';

// TODO: break this object to seperate variables. TREE SHAKING!!!
var BANNER_TYPE = {
  TOP_BANNER: 'topbanner',
  BOTTOM_SHEET: 'bottomsheet',
  APP_DIALOG: 'appdialog',
  DESKTOP_DRAWER: 'desktopdrawer',
  DESKTOP_POPUP: 'dwebpip',
  INLINE_CARD: 'inlinecard',
  FULL_PAGE: 'fullpagesheet',
  MWEB_RECENT_SEARCH_CARD: 'mwebrecentsearchcard',
  BOTTOM_BAR: 'bottombar',
  INLINE_CARD_DESKTOP: 'inlinecarddesktop',
  FLOATING_BTN: 'floatingbtn'
};
var DWEB_RECENT_SEARCH_CARD = 'dwebrecentsearchcard';

var CTA_TYPE = {
  PLAYSTORE: 'playstore',
  APPSTORE: 'appstore',
  QR_CODE: 'qrcode'
};
var hideTopBannerEventName = 'hideTopBanner';
var showTopBannerEventName = 'showTopBanner';
var triggerLoadEventName = 'bannerLoad';

export { BANNER_TYPE as B, CTA_TYPE as C, DesktopDrawerDefaultText as D, FloatingBarDefaultText as F, HOC_API_RESPONSE as H, InlineCardBannerDefaultText as I, MwebRecentSearchCardText as M, TopBannerDefaultText as T, BottomBarDefaultText as a, BottomSheetDefaultText as b, FullPageDefaultText as c, DesktopSidePopupDefaultText as d, InlineCardBannerDesktopDefaultText as e, DWEB_RECENT_SEARCH_CARD as f, DwebRecentSearchCardText as g, hideTopBannerEventName as h, showTopBannerEventName as s, triggerLoadEventName as t };
